/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */

import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import { useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom';

import Page from '../../../components/Page';
import subscriptionServices from '../../../services/subscriptionServices';
import adminServices from '../../../services/adminServices';
import SnackBar from '../../../components/snackbar/snackbar';

import { OverviewTab, ContentTab, SubscribersTab, AuditLogTab } from './components/detail/DetailTabs';
import EditDrawer from './components/detail/EditDrawer';
import { StatusChip } from './components/shared/SharedComponents';

const INNER_TABS = ['Overview', 'Content', 'Subscribers', 'Audit Log'];
const LOCKED_TABS = [3];

const DetailSkeleton = () => (
  <div className="max-w-[900px] mx-auto px-8 py-6">
    <Skeleton width={140} height={18} sx={{ mb: 2 }} />
    <Skeleton width="45%" height={32} sx={{ mb: 1 }} />
    <div className="flex gap-6 border-b border-gray-200 mb-6 mt-5">
      {[1, 2, 3, 4].map((i) => <Skeleton key={i} width={80} height={16} sx={{ mb: '8px' }} />)}
    </div>
    <Skeleton width="100%" height={80} sx={{ mb: 2 }} />
    <div className="flex gap-[14px] mb-2">
      <Skeleton width="33%" height={80} />
      <Skeleton width="33%" height={80} />
      <Skeleton width="33%" height={80} />
    </div>
    <Skeleton width="100%" height={220} />
  </div>
);

const PlanDetail = () => {
  const { planType, id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const planSource = location.state?.source || searchParams.get('source') || null;

  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeInnerTab, setActiveInnerTab] = useState(0);
  const [editOpen, setEditOpen] = useState(searchParams.get('edit') === 'true');
  const [toggling, setToggling] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, title: '' });
  console.log(plan,"plan");
  

  useEffect(() => { fetchPlan(); }, [id, planType]);

  const fetchPlan = async () => {
    setLoading(true);
    try {
      // const res = planSource === 'B2B_TEMPLATE'
      //   ? await subscriptionServices.getB2BTemplatePlanById(id)
      //   : await subscriptionServices.getSubscriptionPlanById(id);
      const res = await subscriptionServices.getSubscriptionPlanById(id,planSource, true );
      if (res.ok) {
      const found = res.data?.rows?.[0] || (Array.isArray(res.data) ? res.data[0] : res.data);
        if (found?.id) {
          const allDetails = Array.isArray(found.courseDetails) ? found.courseDetails : [];
          const assessmentDetails = (Array.isArray(found.assessmentDetils) && found.assessmentDetils.length > 0)
            ? found.assessmentDetils
            : (Array.isArray(found.assessmentDetails) && found.assessmentDetails.length > 0)
              ? found.assessmentDetails
              : allDetails.filter((d) => d.type === 'assessment');
         setPlan({
           ...found,
           planType: found.planType || planType,
           scope: found.scope || 'platform',
           description: found.description || '',
           courses: Array.isArray(found.courseDetailsNew) && found.courseDetailsNew.length > 0
             ? found.courseDetailsNew
             : allDetails.filter((d) => d.type === 'course'),
           assessments: assessmentDetails,
           tier: found.tier || null,
            featureBullets: found.featureBullets || found.feature_bullets || [],
            maxAttempts: found.maxAttempts || found.max_attempts || 5,
            displayName: (() => {
              try {
                const raw = found.shortDescription || found.short_desc || '';
                if (!raw) return '';
                if (Array.isArray(raw)) return raw[0] || '';
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed[0] || '' : raw;
              } catch {
                return '';
              }
            })(),
            stripeProductId: found.stripeProductId || found.stripe_product_id || found.prices?.[0]?.stripePriceId || '',
            createdDate: found.createdDate || found.create_datetime || '',
            imageUrl: found.imageUrl || found.image_url || '',
            billing_type: found.billing_type || '',
         });
        } else {
          setPlan(null);
        }
      }
    } catch (e) { console.error('[fetchPlan]', e); }
    setLoading(false);
  };

  const audienceFilter = planType === 'b2b' ? ['B2B', 'BOTH'] : ['B2C', 'BOTH'];

const assessmentFetchFn = ({ page = 1, pageSize = 10, search = '', audience = audienceFilter,  assessment_tier = plan.tier,  assessment_type = plan.categoryId } = {}) =>
    adminServices.getGenericAssessmentDropDown({ page, pageSize, search, audience: (audience || []).join(','),assessment_tier,assessment_type });

  const planIsFree = plan?.isPaid === 'Free';

  const courseFetchFn = ({ page = 1, pageSize = 10, search = '' } = {}) =>
    adminServices.getLookUpData(['course'], {
      page,
      pageSize,
      search,
      audienceFilter,
      isFree: planType === 'b2b'
        ? null
        : planType === 'bundle'
          ? false
          : planIsFree
    }).then((r) => ({
      ok: r.ok,
      data: r.data.course?.data || [],
      total: r.data.course?.total || 0,
    }));

const planStatus = (() => {
    if (!plan) return 'draft';
    const isOnline = plan?.isOnline === true || plan?.isOnline === 'true';
    const isActive = plan?.isActive === true || plan?.isActive === 'true';
    if (!isActive && !isOnline) return 'deleted';
    if (isActive && isOnline) return 'published';
    return 'draft';
})();


  const isDeleted = planStatus === 'deleted';
const handleToggleStatus = async () => {
    setToggling(true);
    try {
      const isB2BTemplate = planSource === 'B2B_TEMPLATE';
      console.log('isB2BTemplate==>',isB2BTemplate)
      if (planStatus === 'draft' || planStatus === 'deleted') {
        // Draft -> Live: hits the new "make live" endpoint, which creates the
        // Stripe product/price for the first time and flips is_active = true.
        const res = await subscriptionServices.SubscriptionPlanLive(id, planType,plan.tier, isB2BTemplate);
        if (res.ok || res.status === 200) {
          setSnackbar({ open: true, title: 'Plan published' });
          fetchPlan();
        }
      } else {
        // Live -> Draft: stays exactly as-is, normal putSubscriptionPlan, no Stripe creation.
        const fd = isB2BTemplate
          ? buildB2BTemplateFormData({ isOnline: 'false' })
          : buildFormData({ isOnline: 'false' });
        const res = isB2BTemplate
          ? await subscriptionServices.putB2BTemplatePlan(id, fd)
          : await subscriptionServices.putSubscriptionPlanStatus(id, fd, planType);
        if (res.ok || res.status === 200) {
          setSnackbar({ open: true, title: 'Plan moved to draft' });
          const tabIndex = { assessment: 0, single: 1, bundle: 2, b2b: 3 };
          // setTimeout(() => navigate(`/app/subscription?tab=${tabIndex[planType] ?? 0}`), 1200);
          fetchPlan();
        }
      }
    } catch (e) { console.error('[handleToggleStatus]', e); }
    setToggling(false);
  };

  const handleSaveEdit = async (values) => {
    console.log(values,"0000000000000");
    
    try {
      const isB2BTemplate = planSource === 'B2B_TEMPLATE';
      if (values._action === 'delete') {
        let res;
        if (isB2BTemplate) {
          const fd = new FormData();
          fd.append('name', plan.name);
          fd.append('isOnline', 'false');
          res = await subscriptionServices.putB2BTemplatePlan(id, fd);
        } else {
          const fd = buildFormData({ isOnline: 'false' });
          res = await subscriptionServices.putSubscriptionPlan(id, fd, planType);
        }
        if (res.ok) {
          setSnackbar({ open: true, title: 'Plan moved to draft' });
          const tabIndex = { assessment: 0, single: 1, bundle: 2, b2b: 3 };
          setTimeout(() => navigate(`/app/subscription?tab=${tabIndex[planType] ?? 0}`), 1200);
        }
        return;
      }
      const fd = new FormData();
      Object.entries(values).forEach(([k, v]) => {
        if (k === '_action' || v === null || v === undefined) return;
        if (v instanceof File) fd.append(k, v);
        else if (Array.isArray(v) || typeof v === 'object') fd.append(k, JSON.stringify(v));
        else fd.append(k, v);
      });

      const res = isB2BTemplate
        ? await subscriptionServices.putB2BTemplatePlan(id, fd)
        : await subscriptionServices.putSubscriptionPlan(id, fd, planType);

      if (res.ok) {
        setEditOpen(false);
        setSnackbar({ open: true, title: 'Plan updated' });
        fetchPlan();
      }
    } catch (e) { console.error('[handleSaveEdit]', e); }
  };

 const buildFormData = (extra = {}) => {
    const fd = new FormData();
    fd.append('name', plan.name);
    if (!('isOnline' in extra)) fd.append('isOnline', String(plan.isOnline ?? false));
   fd.append('isPaid', plan.isPaid === 'Paid' || plan.isPaid === true ? 'true' : 'false');
   fd.append('subscriptionType', plan.subscriptionType?.code || (planType === 'b2b' ? 'B2B' : 'B2C'));
   fd.append('prices', JSON.stringify(
     (plan.prices || []).map(p => ({
       currencyType: p?.currencyType?.code || p?.currencyType,
       actualCost: p?.actualCost ?? 0,
     }))
   )); 
   fd.append('frequency', plan.billingCycle === 'YEARLY' || plan.billingCycle === 'Yearly' ? '1' : '2');
   fd.append('planType', planType);
   fd.append('scope', plan.scope || 'platform');
   fd.append('description', plan.description || '');
   fd.append('shortDescription', JSON.stringify(plan.displayName ? [plan.displayName] : []));
   fd.append('tier', plan.tier || 'BASIC');
   fd.append('assessment_types', JSON.stringify(plan.assessmentTypes || []));
   fd.append('feature_bullets', JSON.stringify(plan.featureBullets || []));
   fd.append('is_popular', plan.isPopular ? 'true' : 'false');
   fd.append('cta_label', plan.ctaLabel || '');
   fd.append('footnote', plan.footnote || '');
   fd.append('plan_category', plan.planCategory || '');
   fd.append('tagline', plan.tagline || '');
   fd.append('max_attempts_per_assessment', plan.maxAttempts || 5);
   fd.append('subscriptionPlan', plan.subscriptionInfo?.name || '');
   fd.append('billingtype', plan.billing_type || plan.billingtype || '');  // ADD THIS LINE
   if (plan.scope === 'category' && plan.categoryId != null) {
        fd.append('categoryId', String(plan.categoryId));
    }
   if (!('courseIds' in extra)) {
     fd.append('courseIds', JSON.stringify((plan.courses || []).map((c) => Number(c.id))));
   }
   if (!('assessmentIds' in extra)) {
     fd.append('assessmentIds', JSON.stringify((plan.assessments || []).map((a) => Number(a.id))));
   }
   Object.entries(extra).forEach(([k, v]) => fd.append(k, v));
   return fd;
 };

 const buildB2BTemplateFormData = (extra = {}) => {
  const fd = new FormData();
  fd.append('name', plan.name);
  if (!('isOnline' in extra)) fd.append('isOnline', String(plan.isOnline ?? false));
  if (plan.description) fd.append('description', plan.description);
  if (plan.shortDescription) fd.append('shortDescription', plan.shortDescription);
   if (!('courseIds' in extra)) {
     fd.append('courseIds', JSON.stringify((plan.courses || []).map((c) => Number(c.id))));
   }
   if (!('assessmentIds' in extra)) {
     fd.append('assessmentIds', JSON.stringify((plan.assessments || []).map((a) => Number(a.id))));
   }
   Object.entries(extra).forEach(([k, v]) => fd.append(k, v));
   return fd;
 };

  const handleAddAssessment = async (ids) => {
    try {
      const existing = (plan.assessments || []).map((a) => Number(a.id));
      if (plan?.source === 'B2B_TEMPLATE') {
        const fd = buildB2BTemplateFormData({
          assessmentIds: JSON.stringify([...new Set([...existing, ...ids.map(Number)])]),
        });
        await subscriptionServices.putB2BTemplatePlan(id, fd);
      } else {
        const fd = buildFormData({
          assessmentIds: JSON.stringify([...new Set([...existing, ...ids.map(Number)])]),
          courseIds: JSON.stringify((plan.courses || []).map((c) => Number(c.id))),
        });
        await subscriptionServices.putSubscriptionPlan(id, fd, planType);
      }
      await fetchPlan();
    } catch (e) { console.error('[handleAddAssessment]', e); }
  };

  const handleAddCourse = async (ids) => {
    try {
      const existing = planType === 'single' ? [] : (plan.courses || []).map((c) => Number(c.id));
      if (plan?.source === 'B2B_TEMPLATE') {
        const fd = buildB2BTemplateFormData({
          courseIds: JSON.stringify([...new Set([...existing, ...ids.map(Number)])]),
        });
        await subscriptionServices.putB2BTemplatePlan(id, fd);
      } else {
        const fd = buildFormData({
          courseIds: JSON.stringify([...new Set([...existing, ...ids.map(Number)])]),
          assessmentIds: JSON.stringify((plan.assessments || []).map((a) => Number(a.id))),
        });
        await subscriptionServices.putSubscriptionPlan(id, fd, planType);
      }
      await fetchPlan();
    } catch (e) { console.error('[handleAddCourse]', e); }
  };

  const handleDeleteAssessment = async (item) => {
    try {
      const remaining = (plan.assessments || [])
        .filter((a) => Number(a.id) !== Number(item.id))
        .map((a) => Number(a.id));
      if (plan?.source === 'B2B_TEMPLATE') {
        const fd = buildB2BTemplateFormData({ assessmentIds: JSON.stringify(remaining) });
        await subscriptionServices.putB2BTemplatePlan(id, fd);
      } else {
        const fd = buildFormData({
          assessmentIds: JSON.stringify(remaining),
          courseIds: JSON.stringify((plan.courses || []).map((c) => Number(c.id))),
        });
        await subscriptionServices.putSubscriptionPlan(id, fd, planType);
      }
      await fetchPlan();
    } catch (e) { console.error('[handleDeleteAssessment]', e); }
  };

  const handleDeleteCourse = async (item) => {
    try {
      const remaining = (plan.courses || [])
        .filter((c) => Number(c.id) !== Number(item.id))
        .map((c) => Number(c.id));
      if (plan?.source === 'B2B_TEMPLATE') {
        const fd = buildB2BTemplateFormData({ courseIds: JSON.stringify(remaining) });
        await subscriptionServices.putB2BTemplatePlan(id, fd);
      } else {
        const fd = buildFormData({
          courseIds: JSON.stringify(remaining),
          assessmentIds: JSON.stringify((plan.assessments || []).map((a) => Number(a.id))),
        });
        await subscriptionServices.putSubscriptionPlan(id, fd, planType);
      }
      await fetchPlan();
    } catch (e) { console.error('[handleDeleteCourse]', e); }
  };

  const handleDeletePlan = async () => {
    try {
      let res;
      if (planSource === 'B2B_TEMPLATE') {
        res = await subscriptionServices.deleteB2BTemplatePlan(id);
      } else {
        res = await subscriptionServices.deleteSubscriptionPlans(id);
      }
      if (res.status === 200) {
        setSnackbar({ open: true, title: 'Plan deleted successfully' });
        const tabIndex = { assessment: 0, single: 1, bundle: 2, b2b: 3 };
        setTimeout(() => navigate(`/app/subscription?tab=${tabIndex[planType] ?? 0}`), 1200);
      }
    } catch (e) { console.error('[handleDeletePlan]', e); }
  };

  if (loading) return <Page title="Plan Detail"><DetailSkeleton /></Page>;

  if (!plan) return (
    <Page title="Plan Detail">
      <div className="max-w-[900px] mx-auto px-8 py-12 text-center">
        <p className="text-[16px] text-gray-500">Plan not found.</p>
        <button onClick={() => {
          const tabIndex = { assessment: 0, single: 1, bundle: 2, b2b: 3 };
          navigate(`/app/subscription?tab=${tabIndex[planType] ?? 0}`);
        }}
          className="mt-4 bg-blue-600 text-white border-none rounded-[7px] px-4 py-2 text-[13px] cursor-pointer hover:bg-blue-700">
          Back to Plans
        </button>
      </div>
    </Page>
  );


  return (
    <Page title="">
      <div className="max-w-[900px] mx-auto px-4 md:px-8 py-6">

        <button
          type="button"
          onClick={() => {
            const tabIndex = { assessment: 0, single: 1, bundle: 2, b2b: 3 };
            navigate(`/app/subscription?tab=${tabIndex[planType] ?? 0}`);
          }}
          className="inline-flex items-center gap-[5px] text-[13px] text-gray-700 cursor-pointer mb-[18px] hover:text-gray-900 bg-transparent border-none"
        >
          <span className="text-[16px]">‹</span> Plans &amp; Pricing
        </button>

        {/* Heading */}
        <div className="flex items-center gap-3 mb-5 flex-wrap">
          <p className="text-[24px] font-bold text-gray-900">{plan?.name}</p>
        <StatusChip status={(plan?.isOnline  === true && plan?.isActive  === true ) ? 'published' :'draft'} />
        </div>

        <div className="border-b border-gray-200 mb-6" style={{ borderBottomWidth: '1.5px' }}>
          <div className="flex">
            {INNER_TABS.map((tab, idx) => {
              const isLocked = LOCKED_TABS.includes(idx);
              const isHidden = isDeleted && tab === 'Subscribers';
              // if (isHidden) return null;  
              return (
                <button
                  key={tab}
                  type="button"
                  onClick={() => { if (!isLocked) setActiveInnerTab(idx); }}
                  className="px-4 py-[10px] text-[13px] whitespace-nowrap select-none transition-colors bg-transparent border-none"
                  style={{
                    fontWeight: activeInnerTab === idx ? 600 : 400,
                    color: isLocked ? '#d1d5db' : activeInnerTab === idx ? '#2563eb' : '#6b7280',
                    borderBottom: activeInnerTab === idx ? '2px solid #2563eb' : '2px solid transparent',
                    marginBottom: '-1.5px',
                    cursor: isLocked ? 'not-allowed' : 'pointer',
                  }}
                  title={isLocked ? 'Coming soon' : undefined}
                >
                  {tab}{isLocked && <span className="ml-[5px] text-[10px]">🔒</span>}
                </button>
              );
            })}
          </div>
        </div>

        {activeInnerTab === 0 && (
          <OverviewTab
            plan={plan}
            planType={planType}
            planStatus={planStatus}
            onEdit={() => setEditOpen(true)}
            onToggleStatus={handleToggleStatus}
            toggling={toggling}
            onDelete={handleDeletePlan}
          />
        )}   
         
        {activeInnerTab === 1 && (
          <ContentTab
            plan={plan}
            planType={planType}
            planStatus={planStatus}    
            onAddAssessment={handleAddAssessment}
            onAddCourse={handleAddCourse}
            onDeleteAssessment={handleDeleteAssessment}
            onDeleteCourse={handleDeleteCourse}
            assessmentFetchFn={assessmentFetchFn}
            courseFetchFn={courseFetchFn}
            audienceIds={null}
          />
        )}       
        {activeInnerTab === 2 && <SubscribersTab plan={plan} />}
        {activeInnerTab === 3 && <AuditLogTab plan={plan} />}
      </div>

      <EditDrawer open={editOpen} plan={plan} planType={planType} onClose={() => setEditOpen(false)} onSave={handleSaveEdit} assessmentFetchFn={assessmentFetchFn} courseFetchFn={courseFetchFn} />      <SnackBar open={snackbar.open} snackbarTitle={snackbar.title} close={() => setSnackbar({ open: false, title: '' })} />
    </Page>
  );
};

export default PlanDetail;